
































































// @ is an alias to /src
import { Component, Vue } from "vue-property-decorator";
import apiFlux from "@/api/flux";
import EditMercurial from "@/components/flux/edit/EditMercurial.vue";
import { VuetifyConfirmObject } from "vuetify-confirm";
import { directPayloadQuery } from "@/utils/api";
import { AloMercurial } from "@/models/alo/AloMercurial";
import { AloFlux, getDefaultAloFlux } from "@/models/alo/AloFlux";

@Component({
  name: "ReadMercurial",
  components: { EditMercurial },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    mercurials: {
      type: Array,
      default: [],
      required: true,
    },
    flux: {
      type: Object,
      default: getDefaultAloFlux(),
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
})
export default class ReadMercurial extends Vue {
  private mercurials!: Array<AloMercurial>;
  private loading!: boolean;
  private flux!: AloFlux;

  private headersCat = [
    { text: "Codic", value: "mrcCodic", width: "32%" },
    { text: "Tarif HT", value: "mrcPxFinalHt", width: "32%" },
    { text: "Erreur", value: "computingError", width: "32%" },
    { text: "", value: "action", width: 20 },
  ];

  edit() {
    (this.$refs.editMercurial as EditMercurial).edit(
      this.mercurials,
      this.flux
    );
  }

  get mercurialTxt() {
    return `Codic\tTarif HT\n${this.mercurials
      .map(
        (m) => `${m.mrcCodic}\t${m.mrcPxFinalHt.toString().replace(".", ",")}`
      )
      .join("\n")}`;
  }

  onCopy() {
    this.$store.myActions.UI_ADD_SNACK_MESSAGE(
      "Mercurial infos copiées dans le presse papier"
    );
  }

  deleteMercurial(item: AloMercurial) {
    this.$confirm(
      `Voulez vous vraiment supprimer la mercurial : ${item.mrcCodic} : ${item.mrcPxFinalHt}€?`,
      { title: "Attention" } as VuetifyConfirmObject
    ).then((answer) => {
      if (answer) {
        const idx = this.mercurials.findIndex(
          (it) =>
            it.mrcCodic == item.mrcCodic && it.mrcPxFinalHt == it.mrcPxFinalHt
        );
        if (idx > -1) {
          this.$set(item, "deleted", true);
          this.mercurials.splice(idx, 1);
          directPayloadQuery(
            apiFlux.saveMercurial,
            { id: this.flux.id, mercurials: this.mercurials },
            this.$store
          );
        }
      }
    });
  }

  get mercurialScope() {
    return this.flux.flcMercurialScope &&
      this.flux.flcMercurialScope.length > 0 &&
      this.flux.flcMercurialScope != "Default"
      ? this.flux.flcMercurialScope.split(", ")
      : [];
  }

  get flcMercurialMode() {
    if (this.flux.flcMercurialMode == "UseTac")
      return "Option tarif animé commercialement: Tarif = min(Prix de base, Prix URM, Prix mercuriale, Prix TAC)";
    else if (this.flux.flcMercurialMode == "ForceMercurial")
      return "Option Tarif mercuriale systématique: Tarif = Prix mercuriale dans tous les cas";
    else
      return "Option standard: Tarif = min(Prix de base, Prix URM, Prix mercuriale)";
  }
}
